export const StepType = {
  CREATE_CONFIG: 'create_config',
  CREATE_MAPPING: 'create_mapping',
  IMPORT_IS_PROCESSING: 'import_is_processing',
};
